import {
  LuAlignJustify,
  LuChevronDown,
  LuShip,
  LuUser2,
  LuX,
} from "react-icons/lu";
import {
  RiHome2Line,
  RiLogoutBoxLine,
  RiShipLine,
  RiSignpostLine,
} from "react-icons/ri";
import { Link, useLocation } from "react-router-dom";
import { Logo } from "../../../assets/img";
import { useGlobalState } from "../../../context/GlobalStateContext";
import { SITELINKS } from "../../../app-routes/links";
import { FaBell, FaHouse, FaSignsPost } from "react-icons/fa6";
import { useEffect, useRef, useState } from "react";
import apiClient from "../../../api-services/ApiClient";
import Preloader from "../../../app-components/preloader/Preloader";
import DOMPurify from "dompurify";
import { AiOutlineHome, AiOutlinePushpin, AiOutlineSafetyCertificate } from "react-icons/ai";
import { APP_AUTH_LOGOUT } from "../../../api-services/Process";

const HeaderOperator = () => {
  const { state } = useGlobalState();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [isOpenNotification, setIsOpenNotification] = useState(false);
  const [isOpenPOption, setIsOpenPOption] = useState(false);

  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const notificationRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    getAllNotifications();
  }, []);

  /**
   *  # getAllNotifications
   */
  const getAllNotifications = async () => {
    setLoading(true);

    try {
      const res: any = await apiClient.get("NotificationMessage");
      setNotifications(res.data.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const sanitizeHTML = (html: string | undefined) => {
    return { __html: DOMPurify.sanitize(html || "") };
  };
  const toggleDropdown = () => {
    setIsOpenNotification(!isOpenNotification);
  };

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  // handle-login-submit
  const handleLogout = async () => {
    setLoading(true);
    try {

      window.location.replace(
        APP_AUTH_LOGOUT ?? ''
      );
      
    } catch (error: any) {
      console.log(JSON.stringify(error));
    } finally {
      setLoading(false);      
      window.location.reload();
      // navigate("/")
    }
  };

  return (
    <header className="bg-white shadow fixed top-0 w-full z-50">
      <div className="xl:container md:px-4 flex items-center justify-between gap-4 mx-auto">
        <div className="flex justify-start items-center 2xl:gap-16 gap-10">
          {/* logo area */}
          <div className="flex items-center py-2">
            <div className="pr-5 xl:hidden">
              <button
                onClick={toggleSidebar}
                className="rounded p-1.5 bg-slate-200"
              >
                {isOpen ? (
                  <LuX className="text-[#191ead] mr-1" />
                ) : (
                  <span className="">
                    <LuAlignJustify className="text-2xl text-[#191ead]" />
                  </span>
                )}
              </button>
            </div>

            <img
              src={Logo}
              alt="header-logo"
              className="w-[75px] h-[42px] 2xl:w-[75px] 2xl:h-[42px] pr-3"
            />

            <div className="2xl:pl-5 xl:pl-2 xl:text-[16px] md:text-[12px] font-bold nunito">
              <p className="">Marine Vessel Inspection Portal (MVIP)</p>
            </div>
          </div>

          {/* nav area */}
          <nav className="hidden">
            <ul className="flex  items-center gap-6 text-[12px] text-slate-900 font-medium mt-[px]">
              <li
                className={`${
                  location.pathname === SITELINKS.DASHBOARD_VO &&
                  "link-active text-red-500"
                } py-3`}
              >
                <Link
                  to={SITELINKS.DASHBOARD_VO}
                  className="flex gap-2 items-center py-2 px-2 hover:bg-slate-50 hover:text-slate-800 rounded"
                >
                  <FaHouse />
                  <span>Dashboard</span>
                </Link>
              </li>

              <li
                className={`${
                  location.pathname.match("inspection") &&
                  "link-active text-red-500"
                } py-3`}
              >
                <Link
                  to={SITELINKS.VO_INSPECTION}
                  className="flex gap-2 items-center py-2 px-2 hover:bg-slate-50 hover:text-slate-800 rounded"
                >
                  <LuShip />
                  <span>Inspection History</span>
                </Link>
              </li>

              <li
                className={`${
                  location.pathname.match("action-tracker") &&
                  "link-active text-red-500"
                } py-3`}
              >
                <Link
                  to={SITELINKS.VO_TRACKER}
                  className="flex gap-2 items-center py-2 px-2 hover:bg-slate-50 hover:text-slate-800 rounded"
                >
                  <FaSignsPost />
                  <span>Action Tracker</span>
                </Link>
              </li>
            </ul>
          </nav>
        </div>

        {/* users -info area */}
        <div className="flex gap-4 items-center">
          {/* desktop nav area */}
          <nav className="hidden xl:flex">
            <ul className="flex items-center gap-5 text-[12px] text-black font-bold nunito">
              <li className="py-3">
                <Link
                  to={SITELINKS.DASHBOARD_VO}
                  className="relative flex gap-2 items-center py-2 px-2 hover:bg-slate-100 rounded"
                >
                  <AiOutlineHome className="text-red-600 text-lg" />
                  <span
                    className={`${
                      location.pathname === SITELINKS.DASHBOARD_VO
                        ? "after:content-[''] after:absolute after:left-1/4 after:bottom-[-11px] after:w-1/2 after:h-[3px] after:bg-red-600 after:rounded-t-full"
                        : "after:content-[''] after:absolute after:left-1/4 after:bottom-[-11px] after:w-1/2 after:h-[3px] after:bg-red-600 after:rounded-t-full after:scale-x-0 after:transition-transform after:duration-300 hover:after:scale-x-100"
                    }`}
                  >
                    Dashboard
                  </span>
                </Link>
              </li>

              <li className="py-3">
                <Link
                  to={SITELINKS.VO_INSPECTION}
                  className="relative flex gap-2 items-center py-2 px-2 hover:bg-slate-100 rounded"
                >
                  <AiOutlineSafetyCertificate className="text-red-600 text-lg" />
                  <span
                    className={`${
                      location.pathname.match("inspection")
                        ? "after:content-[''] after:absolute after:left-1/4 after:bottom-[-11px] after:w-1/2 after:h-[3px] after:bg-red-600 after:rounded-t-full"
                        : "after:content-[''] after:absolute after:left-1/4 after:bottom-[-11px] after:w-1/2 after:h-[3px] after:bg-red-600 after:rounded-t-full after:scale-x-0 after:transition-transform after:duration-300 hover:after:scale-x-100"
                    }`}
                  >
                    Inspection History
                  </span>
                </Link>
              </li>

              <li className="py-3">
                <Link
                  to={SITELINKS.VO_TRACKER}
                  className="relative flex gap-2 items-center py-2 px-2 hover:bg-slate-100 rounded"
                >
                  <AiOutlinePushpin className="text-red-600 text-lg" />
                  <span
                    className={`${
                      location.pathname === SITELINKS.VO_TRACKER
                        ? "after:content-[''] after:absolute after:left-1/4 after:bottom-[-11px] after:w-1/2 after:h-[3px] after:bg-red-600 after:rounded-t-full"
                        : "after:content-[''] after:absolute after:left-1/4 after:bottom-[-11px] after:w-1/2 after:h-[3px] after:bg-red-600 after:rounded-t-full after:scale-x-0 after:transition-transform after:duration-300 hover:after:scale-x-100"
                    }`}
                  >
                    Action Tracker
                  </span>
                </Link>
              </li>
            </ul>
          </nav>

          {/* notification panel area */}
          <div className="relative pl-5" ref={notificationRef}>
            <button
              onClick={toggleDropdown}
              className="relative py-2 flex gap-2 items-center text-xs font-medium bg-gray-100 px-2 rounded-full hover:bg-slate-200 transition-colors duration-300 ease-in-out transform"
            >
              <span className="h-[9px] w-[9px] bg-red-600 absolute top-[5px] right-[8px] rounded-full border border-gray-100 border-2"></span>
              <FaBell className="text-[16px] text-gray-700" />
            </button>

            {isOpenNotification && (
              <div className="absolute right-[-15px] mt-3 w-[200px] animate-slideInUp">
                <div className="relative">
                  <div className="absolute right-6 top-0 transform -translate-y-full">
                    <div className="w-0 h-0 border-l-8 border-r-8 border-b-8 border-transparent border-b-gray-200"></div>
                  </div>

                  <div
                    className="py-2 bg-white border rounded-md shadow-lg overflow-hidden z-20"
                    style={{
                      height: "20vh",
                      overflowY: "scroll",
                      scrollbarWidth: "thin",
                    }}
                  >
                    {notifications.length === 0 ? (
                      <div className="text-gray-800 px-4 py-2 text-xs">
                        No notification
                      </div>
                    ) : (
                      notifications.map((notification: any) => (
                        <div
                          key={notification?.id}
                          className="block px-4 py-2 text-gray-900 hover:bg-gray-100 text-[9px] notification-link border-b border-1 border-[#ccc]"
                        >
                          <div
                            dangerouslySetInnerHTML={sanitizeHTML(
                              notification?.message
                            )}
                          />
                        </div>
                      ))
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* users - info & option dropdown area */}
          <div className="relative" ref={dropdownRef}>
            <button
              onClick={() => setIsOpenPOption(!isOpenPOption)}
              className={`hover:bg-slate-200 py-1 flex gap-1 items-center text-xs font-medium bg-gray-100 px-3 rounded-full transition-colors duration-300 ease-in-out transform ${
                isOpenPOption &&
                "outline-[2px] outline -black rounded-t-md  rounded-b-none"
              }`}
            >
              <LuUser2 className="text-lg m-1 text-red-700" />
              <span className="whitespace-nowrap text-[12px] text-black nunito font-bold">
                Hello, {state?.tepnguser?.user?.firstName}
              </span>

              <LuChevronDown
                className={`text-lg text-red-700 transition-transform duration-500 ${
                  isOpenPOption && "rotate-180"
                }`}
              />
            </button>

            {isOpenPOption && (
              <ul
                style={{ left: "px", top: "32px" }}
                className={`absolute mt-1 space-y-1 bg-white border border-gray-300 py-2 rounded-md shadow-lg w-full left-0 z-10 text-xs animate-slideInUp ${
                  isOpenPOption && "rounded-t-none"
                }`}
              >
                <li>
                  <Link
                    to={SITELINKS.MANUAL_VO}
                    className="block px-4 py-1 text-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700 flex dark:text-gray-300 transition-colors duration-300 ease-in-out transform"
                  >
                    <span className="ml-1">User Manual</span>
                  </Link>
                </li>

                <li>
                  <button
                    onClick={handleLogout}
                    className="block w-full px-4 py-1 text-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700 flex dark:text-gray-300 transition-colors duration-300 ease-in-out transform"
                  >
                    <span className="ml-1">Log out</span>
                  </button>
                </li>
              </ul>
            )}
          </div>
        </div>
      </div>

      {/* pull out Sidebar */}
      <div>
        <div
          className={`fixed top-0 left-0 right-0 h-full w-5/6 md:w-3/6 bg-white dark:bg-slate-700 shadow-lg z-50 text-white transform transition-transform duration-300 ${
            isOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <nav className="p-4 py-16 text-gray-700 dark:text-gray-300 font-medium text-lg overfloy-y-scroll">
            <ul className="text-[#1b1bac]">
              <div className="px-6 font-medium text-2xl pb-3 text-[#191ead]">
                <div className="flex justify-between items-center">
                  <h2 className="">MENU</h2>
                  <button onClick={toggleSidebar} className="">
                    <LuX className="text-red-600 mr-1 text-3xl" />
                  </button>
                </div>
                <hr className="border-1 border mt-6" />
              </div>

              <li className="mb-2">
                <Link
                  to={`${SITELINKS.DASHBOARD_VO}`}
                  onClick={toggleSidebar}
                  className="flex items-center gap-4 p-4 hover:bg-gray-50 dark:hover:bg-slate-800"
                >
                  <RiHome2Line className="text-3xl" />
                  <span className="mt-1">Dashboard</span>
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to={SITELINKS.VO_INSPECTION}
                  onClick={toggleSidebar}
                  className="flex items-center gap-4 p-4 hover:bg-gray-50 dark:hover:bg-slate-800"
                >
                  <RiShipLine className="text-3xl" />
                  <span className="mt-1">Inspection History</span>
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to={SITELINKS.VO_TRACKER}
                  onClick={toggleSidebar}
                  className="flex items-center gap-4 p-4 hover:bg-gray-50 dark:hover:bg-slate-800"
                >
                  <RiSignpostLine className="text-3xl" />
                  <span className="mt-1">Action Tracker</span>
                </Link>
              </li>
              <li className="border-t absolute bottom-[50px] w-5/6">
                <button
                  onClick={handleLogout}
                  className="flex items-center gap-4 p-4 py-6 hover:bg-gray-50 dark:hover:bg-slate-800"
                >
                  <RiLogoutBoxLine className="text-3xl" />
                  <span className="mt-1">Logout</span>
                </button>
              </li>
            </ul>
          </nav>
        </div>

        <div
          onClick={toggleSidebar}
          className={`fixed top-0 left-0 right-0 h-full w-full bg-[#00000092] dark:bg-[#00000099] shadow-lg z-40 text-white transform transition-transform duration-300 ${
            isOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        ></div>
      </div>

      <Preloader loading={loading} />
    </header>
  );
};

export default HeaderOperator;
